(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-corner-gallery]').forEach(gallery => {
      if (gallery.dataset.galleryReady) return;
      const dialog = gallery.querySelector('dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      gallery.dataset.galleryReady = 'true';
      const content = dialog.querySelector('.dc-corner-lightbox__content');
      const more = gallery.querySelector('.dc-corner-gallery-more');
      if (more) more.hidden = true;
      let trigger;
      let previousOverflow;
      const open = (node, target) => {
        trigger = target;
        content.replaceChildren(node);
        if (!dialog.open) {
          previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          dialog.showModal();
        }
      };
      gallery.addEventListener('click', event => {
        const close = event.target.closest('[data-gallery-close]');
        if (close) { dialog.close(); return; }
        const all = event.target.closest('[data-gallery-all]');
        if (all) {
          event.preventDefault();
          const grid = document.createElement('div');
          grid.className = 'dc-corner-gallery-grid';
          gallery.querySelectorAll('.dc-corner-shell [data-gallery-photo]').forEach(photo => grid.append(photo.cloneNode(true)));
          open(grid, all);
          return;
        }
        const photo = event.target.closest('[data-gallery-photo]');
        if (photo) {
          event.preventDefault();
          const img = new Image();
          img.alt = photo.querySelector('img').alt;
          img.src = photo.href;
          open(img, dialog.contains(photo) ? trigger : photo);
        }
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = previousOverflow || '';
        content.replaceChildren();
        if (trigger?.isConnected) trigger.focus();
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
